<template>
  <div class="soar-container pt-12 flex flex-wrap gap-4 md:gap-0">
    <!--  hover:scale-105 -->
    <div
      :key="key"
      v-for="(card, key) in cards"
      class="w-full md:w-1/3 p-2 lg:first:ps-0 lg:end:pe-0 py-0 max-h-fit"
    >
      <div
        class="w-full h-full p-4 flex flex-col justify-start items-center gap-y-3 border border-primary-700 rounded-lg hover:shadow-lg"
      >
        <div class="w-full flex flex-col justify-center items-center gap-4">
          <div
            class="flex justify-center items-center aspect-square bg-brand-gray-300 rounded size-10"
          >
            <faFileLines class="w-4 fill-primary"></faFileLines>
          </div>
          <p class="max-w-prose">{{ $t(card.label) }}</p>
        </div>
        <div class="flex-1 flex flex-col gap-2">
          <div
            :key="key"
            v-for="({ label, value }, key) in card.query.copyOption"
            class="flex gap-x-3"
          >
            <input
              :id="value"
              :value="value"
              type="radio"
              name="copyOption"
              class="accent-primary"
              @change="selectedRadio = value"
            />
            <label :for="value">{{ $t(label) }}</label>
          </div>
        </div>
        <div class="w-full">
          <RouterLink
            :to="{
              name: 'ServiceForm',
              params: { serviceId: 481 },
              query: {
                withException: false,
                dataSource: card.query.dataSource,
                ...(card.label == 'fromLastEntryShipTrip' && { copyOption: selectedRadio })
              }
            }"
            class="w-full flex justify-center items-center gap-x-3 text-xs rounded-full px-3 py-1.5 border border-primary bg-primary text-white font-semibold hover:scale-105"
          >
            {{ $t('startService') }}
            <faCircleArrowRight class="w-4 fill-white" />
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import faCircleArrowRight from '@/assets/icons/faCircleArrowRight.svg?component'
import faFileLines from '@/assets/icons/faFileLines.svg?component'
import { ref } from 'vue'

const selectedRadio = ref()

const cards = [
  {
    label: 'manulaEnreyShipTrip',
    query: { dataSource: 'MANUAL' }
  },
  {
    label: 'fromLastEntryShipTrip',
    query: {
      dataSource: 'LAST-TRIP',
      copyOption: [
        {
          label: 'crewInfo',
          value: 'crew'
        },
        {
          label: 'passengersInfo',
          value: 'passengers'
        },
        {
          label: 'passengersAndCrewInfo',
          value: 'crew-passengers'
        }
      ]
    }
  },
  {
    label: 'SIATEntryShipTrip',
    query: { dataSource: 'SITA' }
  }
]
</script>

<style lang="scss" scoped></style>
